import { Layouts } from 'react-grid-layout';

export const layoutConfig: Layouts | undefined = {
    lg: [
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
    ],
    md: [
        {
            h: 2,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 2,
            i: 'c2',
        },
    ],
    xs: [
        {
            h: 3,
            static: true,
            w: 24,
            x: 0,
            y: 0,
            i: 'c1',
        },
        {
            h: 14,
            static: true,
            w: 24,
            x: 0,
            y: 3,
            i: 'c2',
        },
    ],
};
export const pageConfig: PageConfig = {
    pageProps: {},
    components: [
        {
            key: 'c1',
            name: 'networth-page-header',
            props: {
                header: {
                    title: 'networth',
                },
                rhsComponents: [
                    {
                        name: 'date-range-picker',
                        props: {
                            defaultPeriod: '3M',
                            visiblePeriods: [
                                '1m',
                                '3m',
                                '6m',
                                '1y',
                                'mtd',
                                'qtd',
                                'ytd',
                                'all',
                            ],
                        },
                    },
                ],
            },
        },
        {
            name: 'canopy-collapse',
            key: 'c2',
            props: {
                lhsComponent: {
                    name: 'networth-stacked-chart',
                    // apiDetails: {
                    //     endpoint: `charts/networth?`,
                    //     endpointParams: {
                    //         per_parent_user_ids: 'user_id',
                    //         per_child_user_ids: 'per_child_user_ids',
                    //         from_date: 'from_date',
                    //         to_date: 'to_date',
                    //         parent_user_ids: '*,user_id',
                    //         group_by: 'group_by',
                    //     },
                    // },
                    props: {
                        defaultPeriod: '3M',
                        otherEndPoints: [
                            {
                                child_accounts: 'child_accounts',
                            },
                        ],
                    },
                },
                rhsComponent: {
                    name: 'networth-chart-modifier',
                    props: {
                        // defaultAnalysisType: 'strategy',
                        defaultAnalysisMode: 'individual',
                        defaultNavParam: 'nav_on_assets',
                        defaultStrategy: 'by_entire_account',
                    },
                },
            },
        },
    ],
};
